const externalPlayUrl = {
	'342428': 'https://faithlife.com/vantage-conference-by-awana/activity',
};
export default externalPlayUrl;
